export class Pair {
  /**
   *
   */
  $key: string;
  Description: string;
  IsActive: boolean;
}
